import React from "react";
const Done = (props) => {
    return (
        <div className="">
            <div className="mx-auto w-1/2 pb-4">
                <img src="https://cdn.shippify.co/images/img-error.svg" alt="" className="mx-auto" />
            </div>
            <div className="flex justify-center items-center flex-col mb-5">
                <span className="text-sm w-3/4 text-shippify-darkGray leading-tight text-center pt-6">
                    Sorry we had problems creating your company
                </span>
            </div>
            {/* <div className="flex justify-center items-center mb-4">
                <a
                    href="/login"
                    className="rounded-full bg-white text-shippify-darkGray px-6 h-8 shadow-primary cursor-pointer flex justify-center items-center">
                      Go to shippify  
                </a>
            </div> */}
        </div>
    );
};
export default Done;
